import { render } from "./ImageContainer.vue?vue&type=template&id=48f6a6e0&scoped=true&ts=true"
import script from "./ImageContainer.vue?vue&type=script&lang=ts"
export * from "./ImageContainer.vue?vue&type=script&lang=ts"

import "./ImageContainer.vue?vue&type=style&index=0&id=48f6a6e0&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f6a6e0"]])

export default __exports__